const customQueryStyles = {
  spinnerStyle: {
    marginLeft: '50%',
    marginTop: '50px'
  },
  alignCenter: {
    marginTop: '48px',
    textAlign: 'center'
  },
  noDataHeader: {
    fontFamily: 'OpenSans-SemiBold',
    fontSize: '16px',
    marginBottom: '15px'
  },
  noDataBody: {
    fontFamily: 'OpenSans-Regular',
    fontSize: '16px'
  },
  resultBox: {
    height: '200px',
    background: 'rgba(235,237,239,0.4)',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    opacity: '87%',
    fontSize: '13px'
  },
  spinnerPopUp: {
    position: 'absolute',
    top: '4%',
    left: '50%'
  },
  spinnerStatusPopUp: {
    position: 'absolute',
    top: '22%',
    left: '50%'
  },
  noRecordsFoundMsg: {
    fontSize: '14px',
    fontWeight: '500',
    marginTop: '5%',
    textAlign: 'center'
  }
};
export default customQueryStyles;